import { convertIRateResponseToIRateData, IRateData, IRateResponse } from './IRate';

interface ISimultaneousIssueFlatResponse {
  kind: 'SimultaneousIssueFlatDto';
  premium: number;
}

type ISimultaneousIssueFlatData = ISimultaneousIssueFlatResponse;

interface ISimultaneousIssuePercentBasicResponse {
  kind: 'SimultaneousIssuePercentBasicDto';
  premium: number;
  percentOfBasic: number;
}

type ISimultaneousIssuePercentBasicData = ISimultaneousIssuePercentBasicResponse;

interface ISimultaneousIssuePercentLenderResponse {
  kind: 'SimultaneousIssuePercentLenderDto';
  premium: number;
  percentOfLender: number;
  minimum: number;
}

type ISimultaneousIssuePercentLenderData = ISimultaneousIssuePercentLenderResponse;

interface ISimultaneousIssueRateResponse {
  kind: 'SimultaneousIssueRateDto';
  rate: IRateResponse;
}

interface ISimultaneousIssueRateData {
  kind: 'SimultaneousIssueRateDto';
  rate: IRateData;
}

const convertISimultaneousIssueRateResponseToISimultaneousIssueRateData = ({
  kind,
  rate,
}: ISimultaneousIssueRateResponse): ISimultaneousIssueRateData => ({
  kind,
  rate: convertIRateResponseToIRateData(rate),
});

export type ISimultaneousIssuePremiumResponse =
  | ISimultaneousIssueFlatResponse
  | ISimultaneousIssuePercentBasicResponse
  | ISimultaneousIssuePercentLenderResponse
  | ISimultaneousIssueRateResponse;

export type ISimultaneousIssuePremiumData =
  | ISimultaneousIssueFlatData
  | ISimultaneousIssuePercentBasicData
  | ISimultaneousIssuePercentLenderData
  | ISimultaneousIssueRateData;

export const convertISimultaneousIssuePremiumResponseToISimultaneousIssuePremiumData = (
  response: ISimultaneousIssuePremiumResponse
): ISimultaneousIssuePremiumData => {
  switch (response.kind) {
    case 'SimultaneousIssueRateDto':
      return convertISimultaneousIssueRateResponseToISimultaneousIssueRateData(response);
    default:
      return { ...response };
  }
};
